import { Global } from '@emotion/react';

// @NOTE: you can add fonts in here as necessary, see code samples at the bottom of the file:

function Fonts() {
  return (
    <Global
      styles={`
        /* Monument Extended */

        @font-face {
          font-family: 'Monument Extended Bold';
          src: url('/static/fonts/MonumentExtended/bold.woff2') format('woff2'),
                url('/static/fonts/MonumentExtended/bold.woff') format('woff');
          font-style: normal;
        }

        @font-face {
          font-family: 'Monument Extended Regular';
          src: url('/static/fonts/MonumentExtended/regular.woff2') format('woff2'),
                url('/static/fonts/MonumentExtended/regular.woff') format('woff');
          font-style: normal;
        }

        /* Roobert */

        @font-face {
          font-family: 'Roobert Regular';
          src: url('/static/fonts/Roobert/regular.woff2') format('woff2'),
               url('/static/fonts/Roobert/regular.woff') format('woff');
          font-style: normal;
          font-weight: 400;
        }
      `}
    />
  );
}
export { Fonts };

/* Monument Extended */

/*

@font-face {
  font-family: 'Monument Extended Black';
  src: url('/static/fonts/MonumentExtended/black.woff2') format('woff2'),
        url('/static/fonts/MonumentExtended/black.woff') format('woff');
  font-style: normal;
}

@font-face {
  font-family: 'Monument Extended Book';
  src: url('/static/fonts/MonumentExtended/book.woff2') format('woff2'),
        url('/static/fonts/MonumentExtended/book.woff') format('woff');
  font-style: normal;
}

@font-face {
  font-family: 'Monument Extended Heavy';
  src: url('/static/fonts/MonumentExtended/heavy.woff2') format('woff2'),
        url('/static/fonts/MonumentExtended/heavy.woff') format('woff');
  font-style: normal;
}

@font-face {
  font-family: 'Monument Extended Light';
  src: url('/static/fonts/MonumentExtended/light.woff2') format('woff2'),
        url('/static/fonts/MonumentExtended/light.woff') format('woff');
  font-style: normal;
}

@font-face {
  font-family: 'Monument Extended Medium';
  src: url('/static/fonts/MonumentExtended/medium.woff2') format('woff2'),
        url('/static/fonts/MonumentExtended/medium.woff') format('woff');
  font-style: normal;
}

@font-face {
  font-family: 'Monument Extended Thin';
  src: url('/static/fonts/MonumentExtended/thin.woff2') format('woff2'),
        url('/static/fonts/MonumentExtended/thin.woff') format('woff');
  font-style: normal;
}

*/

/* Roobert */

/*

@font-face {
  font-family: 'Roobert Bold';
  src: url('/static/fonts/Roobert/bold.woff2') format('woff2'),
        url('/static/fonts/Roobert/bold.woff') format('woff');
  font-style: normal;
  font-weight: 700;
}

@font-face {
  font-family: 'Roobert Heavy';
  src: url('/static/fonts/Roobert/heavy.woff2') format('woff2'),
        url('/static/fonts/Roobert/heavy.woff') format('woff');
  font-style: normal;
  font-weight: 900;
}

@font-face {
  font-family: 'Roobert Light';
  src: url('/static/fonts/Roobert/light.woff2') format('woff2'),
        url('/static/fonts/Roobert/light.woff') format('woff');
  font-style: normal;
  font-weight: 200;
}

@font-face {
  font-family: 'Roobert Medium';
  src: url('/static/fonts/Roobert/medium.woff2') format('woff2'),
        url('/static/fonts/Roobert/medium.woff') format('woff');
  font-style: normal;
  font-weight: 500;
}

@font-face {
  font-family: 'Roobert Semibold';
  src: url('/static/fonts/Roobert/semibold.woff2') format('woff2'),
       url('/static/fonts/Roobert/semibold.woff') format('woff');
  font-style: normal;
  font-weight: 600;
}

*/
